// extracted by mini-css-extract-plugin
export default {"quote":"_Quote_quote__cx44U"};